import { Component, OnInit } from "@angular/core";

import { DlvAuthOService } from "../../../shared/services/auth0.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LoaderService } from "./../../services";

// 666 Unused Component

@Component({
  selector: "sync-permissions",
  templateUrl: "./sync-permissions.component.html",
  styleUrls: ["./sync-permissions.component.scss"]
})
export class SyncPermComponent implements OnInit {
  isNoScope = false;
  scopeInterval: any;
  timer = 15;
  time = 3;
  url = '';

  constructor(
    private auth0Service: DlvAuthOService,
    private actRoute: ActivatedRoute,
    private router: Router,
    private loader: LoaderService
  ) {}

  ngOnInit() {
    this.actRoute.queryParams.subscribe((queryParams: any) => {
        this.url = queryParams.prevRoute;
    });
    this.callInterval(this.time * 5);
  }

  checkScope = scopes => {
    let permissions = this.auth0Service.removedUnusedScope(scopes, ['openid', 'profile', 'email']);
    if(scopes && permissions > 0) {
        this.router.navigate(["/"], { replaceUrl: true });
    }else{
      if (this.time) {
        this.callInterval(this.time * 5);
      } else {
          this.isNoScope = false;
          setTimeout(() => {
              this.router.navigate(["/forbidden"], { replaceUrl: true });
          }, 200);
      }
    }
  }

  callInterval = time => {
    if (this.time) {
      this.timer = time;
      this.scopeInterval = setInterval(() => {
        this.timer = this.timer - 1;
        if (this.timer === 1) {
          this.time = this.time - 1;
          this.callRenewToken();
          clearInterval(this.scopeInterval);
        }
      }, 1000);
    } else {
      clearInterval(this.scopeInterval);
    }
  };

  callRenewToken = () => {
    this.loader.start();
    this.auth0Service.renewTokens(false, isCallSuccess => {
      if (isCallSuccess) {
        this.auth0Service.getScopePermission(scopes => {
          this.loader.stop();
          this.checkScope(scopes);
        });
      }else{
        this.loader.stop();
      }
    });
  };

}